/**
 * Copyright 2016 xdot GmbH
 *
 * Author: Marius Runde
 * Date: 05.07.2016
 *
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import GeometryEditControl from './GeometryEditControl';
import { FormLabel } from 'external/react-bootstrap';

class GeometryInput extends React.Component {

    render() {
        let {
            hideLabel,
            InputElement,
            geometry,
            formData,
            featureProperties,
            nameGeometry = 'geometry',
            type,
            required,
            ...otherProps
        } = this.props;

        const g = geometry || (formData && formData.geometry);
        return (
            <React.Fragment>
                { !hideLabel &&
                    <FormLabel>Position { required && <span className="required-symbol"> *</span> }</FormLabel> }
                <GeometryEditControl
                    style={ { height: 500 } }
                    { ...otherProps }
                    handleGeometryChange={ this.props.handleGeometryChange }
                    type={ type }
                    geometry={ g }
                    featureProperties={ featureProperties }
                />

                { InputElement && !required &&
                    <InputElement
                        name={ nameGeometry }
                        type="hidden"
                        value={ g }
                        validations={ {
                            notNull: geometry => !!geometry
                        } }
                    />
                }
                { InputElement && required &&
                    <InputElement
                        name={ nameGeometry }
                        type="hidden"
                        value={ g }
                        validations={ {
                            notNull: geometry => !!geometry
                        } }
                        required/>
                }
            </React.Fragment>
        );
    }
}

GeometryInput.propTypes = {
    defaultPosition: PropTypes.object,
    formData: PropTypes.object,
    featureProperties: PropTypes.object,
    required: PropTypes.bool,
    nameGeometry: PropTypes.string,
    geometry: PropTypes.oneOfType([ PropTypes.object, PropTypes.string ]),
    type: PropTypes.string,
    handleGeometryChange: PropTypes.func.isRequired,
    hideLabel: PropTypes.bool,
    InputElement: PropTypes.func
};

export default GeometryInput;



// WEBPACK FOOTER //
// ./js/components/GeometryInput.jsx